import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=99b971ba&scoped=true&"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=99b971ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b971ba",
  null
  
)

export default component.exports